import React from 'react';
import { Wordmark } from './Wordmark';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-5 pb-28 pt-12 sm:px-6 sm:pb-32" data-id="element-137" data-mp="3gf942tsw627w">
      <div className="mx-auto max-w-2xl text-center" data-id="element-138" data-mp="3ghc0pwojutll">
        <Wordmark tone="light" data-id="element-139" data-mp="32ovukn0cqfgg" />
        <p className="mt-5 text-[12.5px] font-bold uppercase tracking-[0.12em] text-cream/60" data-id="element-140" data-mp="32pp3nums9h1r">
          Educational resource for healthcare professionals
        </p>
        <p className="mt-4 text-[12.5px] leading-relaxed text-cream/45" data-id="element-141" data-mp="3ug3fllb8kjas">
          This material is not a substitute for individualized clinical judgment, diagnosis, treatment
          decisions, current professional guidelines, or applicable local regulations. Clinical
          recommendations should be independently verified against current authoritative sources before
          application to patient care.
        </p>
        <p className="mt-6 text-[12px] text-cream/35" data-id="element-142" data-mp="29xvrqfdrbhqd">
          © {new Date().getFullYear()} Menopause Decision Desk™. All rights reserved.
        </p>
      </div>
    </footer>;
}